import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isOpen", "className", "children"];
import React, { forwardRef, useRef } from 'react';
import { Transition } from 'react-transition-group';
import { Popover as CarnicaPopover } from '@carnica/ui-kit/modules';
import { cnBem, combineRefs } from '@carnica/utils';
import styles from "./styles.pcss";
var cnPopover = cnBem('popover', styles);
var popoverAnimationTimeout = 300;
export var Popover = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var isOpen = _ref.isOpen,
    _className = _ref.className,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var popoverRef = useRef(null);
  return /*#__PURE__*/React.createElement(Transition, {
    in: isOpen,
    nodeRef: popoverRef,
    timeout: popoverAnimationTimeout,
    unmountOnExit: true,
    "data-t-id": "ui-Popover"
  }, function (animate) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      React.createElement(CarnicaPopover, _extends({
        className: function className(dir) {
          return cnPopover('', {
            animate: animate
          }, [typeof _className === 'function' ? _className(dir) : _className]);
        }
        // Вынесено в отдельную рефку для анимации, так как если использовать useForkRef
        ,
        ref: combineRefs([popoverRef, ref])
      }, otherProps), children)
    );
  });
});